import { render, staticRenderFns } from "./profile_orders.vue?vue&type=template&id=22e2df0b&"
import script from "./profile_orders.vue?vue&type=script&lang=js&"
export * from "./profile_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports